import {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import ProductDetail from '../../components/ProductDetail';
import { getMiscById } from '../../data/Misc';

function MiscDetailContainer(){
    const { miscId } = useParams();
    const [item, setItem] = useState(null);
    useEffect(() => {
        console.log(miscId);

        setItem(getMiscById(miscId));
    }, []);

    return <main className="home-container">
        {item && <ProductDetail item={item}/>}
    </main>
}

export default MiscDetailContainer;